import DashboardLayout from "@/components/layouts/DashboardLayout";
import Announcements from "@/pages/dashboard/announcement/Announcements";
import Transaction from "@/pages/dashboard/common/Transaction";
import Home from "@/pages/dashboard/Home";
import Accept from "@/pages/dashboard/settings/Accept";

import Details from "@/pages/dashboard/customers/Details";
import Users from "@/pages/dashboard/customers/Users";
import Settings from "@/pages/dashboard/settings/Settings";
import Transactions from "@/pages/dashboard/transactions/Transactions";
import { Navigate, Route, Routes } from "react-router";
import Balances from "@/pages/dashboard/balances/Balances";
import TeamManagement from "@/pages/dashboard/settings/TeamManagement";
import Profile from "@/pages/dashboard/settings/Profile";
import ApiManagement from "@/pages/dashboard/settings/ApiManagement";
import Marketing from "@/pages/dashboard/settings/Marketing";
import { useAuthState } from "@/context";
import AssetsManagement from "@/pages/dashboard/settings/AssetsManagement";
import Markets from "@/pages/dashboard/markets/Markets";
import WallexRates from "@/pages/dashboard/wallex-rates/WallexRates";
import ExternalRates from "@/pages/dashboard/external-rates/ExternalRates";

const Dashboard = () => {
  const { state } = useAuthState();
  return (
    <Routes>
      <Route
        index
        path="/"
        element={
          <DashboardLayout>
            <Home />
          </DashboardLayout>
        }
      />
      <Route path="/balances/*">
        <Route
          index
          element={
            <DashboardLayout>
              <Balances />
            </DashboardLayout>
          }
        />
      </Route>
      <Route path="/customers/*">
        <Route
          index
          element={
            <DashboardLayout>
              <Users />
            </DashboardLayout>
          }
        />
        <Route
          path=":id"
          element={
            <DashboardLayout>
              <Details />
            </DashboardLayout>
          }
        />
        <Route
          path=":id/:transactionId"
          element={
            <DashboardLayout>
              <Transaction />
            </DashboardLayout>
          }
        />
      </Route>
      <Route path="/transactions/*">
        <Route
          index
          element={
            <DashboardLayout>
              <Transactions />
            </DashboardLayout>
          }
        />
        <Route
          path=":transactionId"
          element={
            <DashboardLayout>
              <Transaction />
            </DashboardLayout>
          }
        />
      </Route>

      <Route
        path="/marketing"
        element={
          <DashboardLayout>
            <Announcements />
          </DashboardLayout>
        }
      />
      <Route
        path="/markets"
        element={
          <DashboardLayout>
            <Markets />
          </DashboardLayout>
        }
      />
      <Route
        path="/wallex-rates"
        element={
          <DashboardLayout>
            <WallexRates />
          </DashboardLayout>
        }
      />
      <Route
        path="/external-rates"
        element={
          <DashboardLayout>
            <ExternalRates />
          </DashboardLayout>
        }
      />
      <Route path="/settings/*">
        <Route
          index
          element={
            <DashboardLayout>
              <Settings />
            </DashboardLayout>
          }
        />
        <Route
          path="general"
          element={
            <DashboardLayout>
              <Profile />
            </DashboardLayout>
          }
        />
        {state?.merchant?.roleId === "merchant-staff" ? (
          <Route
            path="*"
            element={<Navigate replace to="/dashboard/settings" />}
          />
        ) : (
          <>
            <Route
              path="api"
              element={
                <DashboardLayout>
                  <ApiManagement />
                </DashboardLayout>
              }
            />
            <Route
              path="marketing"
              element={
                <DashboardLayout>
                  <Marketing />
                </DashboardLayout>
              }
            />
          </>
        )}
        <Route
          path="asset-management"
          element={
            <DashboardLayout>
              <AssetsManagement />
            </DashboardLayout>
          }
        />
        <Route path="teams/*">
          <Route
            index
            element={
              <DashboardLayout>
                <TeamManagement />
              </DashboardLayout>
            }
          />
        </Route>
        {/* <Route path="teams/invite/accept/:token" element={<Accept />} /> */}
      </Route>
    </Routes>
  );
};

export default Dashboard;
{
  /* </DashboardLayout>  */
}
